const urls = {
  base: '/',
  document: '/document',
  application: '/application',
  applicationExistingApplication: '/application/existing-application',
  applicationPrescreenApplication: '/application/prescreen-application',
  applicationApprovalTerms: '/application/approval-terms',
  applicationPaymentDetails: '/application/payment-details',
  applicationThanks: '/application/thanks',
  contactUs: '/contact-us',
  verification: '/verification',
  error: '/error',
  frequentlyAskedQuestions: '/frequently-asked-questions',
  mixPanelProxyOregon: 'https://mixpanel-proxy.sunbit.com',
  mixPanelProxy: 'https://mixpanel-proxy.sunbit.in',
};

export const TOKEN_REQUIRED_URLS = [
  urls.base,
  urls.application,
  urls.applicationExistingApplication,
  urls.applicationApprovalTerms,
  urls.applicationPaymentDetails,
  urls.applicationThanks,
];

export const EXIT_WITHOUT_PROMPT = [
  urls.applicationThanks,
  urls.contactUs,
  urls.error,
  urls.frequentlyAskedQuestions,
  urls.document,
];
export default urls;
